import React from "react";
import { Table } from "react-bootstrap";
// import { PaginationComponent } from "../Pagination";

export const OrderDataTable = (props) => {
  const { tableStyle, tableData } = props;
  return (
    <>
      <Table borderless responsive className="bg-light">
        <thead style={tableStyle}>
          <tr className="equalWidth">
            <th>Order ID</th>
            <th>User ID</th>
            <th>Address</th>
            <th>Mobile</th>
            <th>Product ID</th>
            <th>Product Name</th>
            <th>Quantity</th>
            <th>Order Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {tableData?.map((d, i) => {
            console.log(d);
            return (
              <tr key={i} style={{ fontSize: ".9em" }} className="equalWidth">
                <td>{d?.order_id}</td>
                <td>{d?.user_id}</td>
                <td>
                  {d?.user_name},<br />
                  {d?.address},<br />
                  {d?.state},<br />
                  {d?.pincode}.
                </td>
                <td>{d?.mobile_no}</td>
                <td>{d?.product_id}</td>
                <td>{d?.product_name}</td>
                <td>{d?.quantity}</td>
                <td>{d?.order_date}</td>
                <td>
                  <span className="badge bg-secondary">{d?.status}</span>
                </td>
              </tr>
            );
          })}
          {/* <tr className="text-right">
            <td colSpan={7}>
              <PaginationComponent />
            </td>
          </tr> */}
        </tbody>
      </Table>
    </>
  );
};
